import {Pipe, PipeTransform} from '@angular/core';
import {FrontIziviaTranslateService} from '../services/i18n/iziviaTranslate.service';
import {ChargePointDto} from '../domain/infra/chargePoint/chargePoint';

@Pipe({
    name: 'stationChargePoint'
})
export class StationChargePointPipe implements PipeTransform {

    constructor(private translateService: FrontIziviaTranslateService) {
    }

    transform(chargePointDto: ChargePointDto): any {
        if (chargePointDto && chargePointDto.stationVisualId && chargePointDto.visualId) {
            return this.translateService.translate('infra.stationAndChargePoint', {
                stationVisualId: chargePointDto.stationVisualId,
                chargePointVisualId: chargePointDto.visualId
            });
        } else if (chargePointDto && chargePointDto.stationVisualId) {
            return this.translateService.translate('infra.station', {stationVisualId: chargePointDto.stationVisualId});
        } else {
            return '';
        }
    }
}
